import { gql } from 'graphql-tag'

export const reminderFragment = gql`
  fragment ReminderFragment on Reminder {
    id
    name
    weekdays
    time
  }
`

const stationChainReminderFragment = gql`
  fragment StationChainReminderFragment on StationChainReminder {
    id
    chainReminderStationId
    name
    weekdays
    time
    muted
    disabled
  }
`

const chainReminderFragment = gql`
  fragment ChainReminderFragment on ChainReminder {
    id
    name
    weekdays
    time
  }
`

export const getStationReminders = gql`
  query GetStationReminders($stationId: ID!) {
    getStationReminders(stationId: $stationId) {
      ...ReminderFragment
    }
    getStationChainReminders(stationId: $stationId) {
      ...StationChainReminderFragment
    }
  }
  ${reminderFragment}
  ${stationChainReminderFragment}
`

export const getAllChainReminders = gql`
  query GetChainReminders {
    getAllChainReminders {
      ...ChainReminderFragment
    }
  }
  ${chainReminderFragment}
`

export const createReminderMutation = gql`
  mutation CreateReminder($stationId: ID!, $data: CreateReminderInputType!) {
    addReminder(stationId: $stationId, data: $data) {
      ...ReminderFragment
    }
  }
  ${reminderFragment}
`

export const updateReminderMutation = gql`
  mutation UpdateReminderMutation($id: ID!, $data: UpdateReminderInputType) {
    updateReminder(id: $id, data: $data) {
      ...ReminderFragment
    }
  }
  ${reminderFragment}
`

export const deleteReminderMutation = gql`
  mutation DeleteReminderMutation($id: ID!) {
    removeReminder(id: $id)
  }
`

export const createChainReminderMutation = gql`
  mutation CreateChainReminder($data: CreateChainReminderInputType!) {
    addChainReminder(data: $data) {
      ...ChainReminderFragment
    }
  }
  ${chainReminderFragment}
`

export const updateChainReminderMutation = gql`
  mutation UpdateChainReminderMutation($id: ID!, $data: UpdateChainReminderInputType) {
    updateChainReminder(id: $id, data: $data) {
      ...ChainReminderFragment
    }
  }
  ${chainReminderFragment}
`

export const updateChainReminderStationMutation = gql`
  mutation UpdateChainReminderStationRelation(
    $chainReminderStationId: ID!
    $data: UpdateChainReminderStationRelationInputType
  ) {
    updateChainReminderStationRelation(chainReminderStationId: $chainReminderStationId, data: $data) {
      ...StationChainReminderFragment
    }
  }
  ${stationChainReminderFragment}
`

export const deleteChainReminderMutation = gql`
  mutation DeleteChainReminderMutation($id: ID!) {
    removeChainReminder(id: $id)
  }
`
